import { BenefitSummaryList } from "./benefit-summary";

export class BeneficiaryCard {
	categoryName: string;
	enrollmentName: string;
	primaryMemberName: string;
	categoryId: number;
	benefitNumber: number;
	memberBenefitID: number;
	beneficiariesForDisplay: Beneficiary[];

	constructor() {
		this.categoryName = '';
		this.enrollmentName = '';
		this.primaryMemberName = '';
		this.categoryId = 0;
		this.benefitNumber = 0;
		this.memberBenefitID = 0;
		this.beneficiariesForDisplay = new Array<Beneficiary>();
	}
}

export class Beneficiary {
	memberBenefitBeneficiaryID: number;
	name: string;
	firstName: string;
	lastName: string;
	relationship: string;
	beneficiaryIDNumber: number;
	countryOfCitizenship: string;
	percentage: number;
	isPrimary: boolean;
	isContingent: boolean;
	isSelected: boolean;
	beneficairyType: string;
	memberBenefitID: number;
	tempPercentage: number;

	constructor() {
		this.memberBenefitBeneficiaryID = 0;
		this.name = null;
		this.firstName = null;
		this.lastName = null;
		this.relationship = null;
		this.beneficiaryIDNumber = 0;
		this.countryOfCitizenship = null;
		this.percentage = 0;
		this.isPrimary = false;
		this.isContingent = false;
		this.isSelected = false;
		this.beneficairyType = null;
		this.memberBenefitID = 0;
		this.tempPercentage = 0;
	}
}

export class BeneficiaryByBenefitPayload {
	benefitID: number;
}

export class BeneficiaryPayload {
	beneficiaryList: Beneficiary[];

	constructor() {
		this.beneficiaryList = new Array<Beneficiary>();
	}
}

export class BeneficiariesResponse {
	public allBeneficiariesValid: boolean;
	public invalidBeneficiaryWarning: string;
	public instructionHTML: string;
	public benefitBeneficiaryCards: BenefitBeneficiaryCard[];
}

export class BenefitBeneficiaryCard {
	public enrollmentName: string;
	public primaryMemberName: string;
	public categoryName: string;
	public memberBenefitID: number;
	public beneficiariesForDisplay: Beneficiary[];
	public genericBenefitSummaryModel: BenefitSummaryList;

	constructor() {
		this.enrollmentName = '';
		this.primaryMemberName = '';
		this.categoryName = '';
		this.memberBenefitID = 0;
		this.beneficiariesForDisplay = new Array<Beneficiary>();
		this.genericBenefitSummaryModel = new BenefitSummaryList();
	}
}

export class BeneficiariesList {
	public beneficiaryCards: BeneficiaryCard[];
}

export class SaveBeneficiariesPortalCriteria {
	memberBenefitIDs: number[];
	beneficiaries: Beneficiary[];

	constructor() {
		this.memberBenefitIDs = new Array<number>();
		this.beneficiaries = new Array<Beneficiary>();
	}
}

